import apiService, { ApiResponse } from './api';

export interface SupportTicket {
  id: string;
  user_id: string;
  title: string;
  description: string;
  status: 'open' | 'in_progress' | 'resolved' | 'closed';
  priority: 'low' | 'medium' | 'high' | 'urgent';
  category?: string;
  assigned_to?: string;
  created_at: string;
  updated_at: string;
  resolved_at?: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  assigned_first_name?: string;
  assigned_last_name?: string;
}

export interface CreateTicketData {
  title: string;
  description: string;
  category?: string;
  priority?: 'low' | 'medium' | 'high' | 'urgent';
}

export interface UpdateTicketData {
  title?: string;
  description?: string;
  status?: 'open' | 'in_progress' | 'resolved' | 'closed';
  priority?: 'low' | 'medium' | 'high' | 'urgent';
}

class SupportApiService {
  // Create a support ticket
  async createTicket(data: CreateTicketData): Promise<ApiResponse<SupportTicket>> {
    try {
      const response = await apiService.post<ApiResponse<SupportTicket>>('/support/tickets', data);
      return response.data;
    } catch (error) {
      console.error('Error creating support ticket:', error);
      throw error;
    }
  }

  // Get all user's support tickets
  async getTickets(status?: string): Promise<ApiResponse<SupportTicket[]>> {
    try {
      const params = status ? { status } : {};
      const response = await apiService.get<ApiResponse<SupportTicket[]>>('/support/tickets', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching support tickets:', error);
      throw error;
    }
  }

  // Get a single support ticket
  async getTicket(id: string): Promise<ApiResponse<SupportTicket>> {
    try {
      const response = await apiService.get<ApiResponse<SupportTicket>>(`/support/tickets/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching support ticket:', error);
      throw error;
    }
  }

  // Update a support ticket
  async updateTicket(id: string, data: UpdateTicketData): Promise<ApiResponse<SupportTicket>> {
    try {
      const response = await apiService.put<ApiResponse<SupportTicket>>(`/support/tickets/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating support ticket:', error);
      throw error;
    }
  }

  // Delete a support ticket
  async deleteTicket(id: string): Promise<ApiResponse> {
    try {
      const response = await apiService.delete<ApiResponse>(`/support/tickets/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting support ticket:', error);
      throw error;
    }
  }
}

const supportApi = new SupportApiService();
export default supportApi;
